(() => {
  'use strict';
  if (window.__hfPrepublishNonGiftFinderFixes) return;
  window.__hfPrepublishNonGiftFinderFixes = true;
  const cleanFacetUrl = (clear) => {
    const url = new URL(window.location.href);
    // Liquid supplies the untagged collection (or search) destination. Keep
    // current search/preview context while clearing every active facet.
    url.pathname = new URL(clear.href, url).pathname;
    Array.from(url.searchParams.keys()).forEach((key) => {
      if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') url.searchParams.delete(key);
    });
    url.hash = '';
    return url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : '');
  };
  document.addEventListener('click', (event) => {
    const apply = event.target.closest('[data-hf-apply-filters]');
    if (apply) {
      const drawer = apply.closest('menu-drawer');
      const summary = drawer?.querySelector('summary');
      if (drawer && summary && typeof drawer.closeMenuDrawer === 'function') {
        event.preventDefault();
        event.stopImmediatePropagation();
        drawer.closeMenuDrawer(event, summary);
      }
      return;
    }
    const clear = event.target.closest('#MainContent [data-hf-clear-all]');
    if (clear) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(cleanFacetUrl(clear));
      return;
    }
    const edit = event.target.closest('.hf-addon-row.is-added [data-addon-edit]');
    if (edit) {
      const row = edit.closest('.hf-addon-row'); if (!row) return;
      row.classList.add('is-editing');
      const panel = row.querySelector('[data-addon-panel]'); if (panel) panel.hidden = false;
      requestAnimationFrame(() => row.querySelector('[data-addon-input]')?.focus({ preventScroll: true }));
    }
  }, true);
  document.addEventListener('cart:updated', () => {
    document.querySelectorAll('.hf-addon-row.is-editing').forEach((row) => row.classList.remove('is-editing'));
  });
})();
